export const RECORDING_STATUS = Object.freeze({
  INACTIVE: "inactive",
  RECORDING: "recording",
});
